<template>
  <div style="height: 100%;">
    <el-menu mode="horizontal"
             default-active="1"
             @select="handleSelect"
             background-color="#ffffff"
             text-color="#ED7F22"
             style="min-width: 1200px"
    >
      <span class="menu-title">YYVPN</span>
      <!--<el-menu-item class="menu-title" index="1">YY OpenVPN</el-menu-item>-->
      <el-submenu index="1" style="float: right;" v-if="isInnerIp">
        <template slot="title"><i class="el-icon-setting" style="color: white"></i></template>
        <el-menu-item index="1-manager">管理</el-menu-item>
      </el-submenu>
    </el-menu>

    <div class="download-content">
      <div class="download_card">
        <div class="phone">
          <div class="screen">
            <div class="vpn-download-pic">
              <img v-if="getHost() === 'ovpn-test.yy.com'" src="@/assets/mobile_home_test.png"
                   style="width: inherit; height: inherit"/>
              <img v-else src="@/assets/mobile_home.png" style="width: inherit; height: inherit"/>
            </div>
            <p>微信扫描二维码</p>
            <p>下载手机客户端</p>
          </div>
        </div>

        <div class="content">
          <div class="title">
            <i class="web-font">立即下载</i>
          </div>
          <div class="desc">让外出办公更方便</div>

          <div class="list">

            <div id="android_version" class="item">
              <a :href="downloadUrl.android.download_url">
                <i class="iconfont">
                  <svg-icon icon-class="android"></svg-icon>
                </i>
                <p>Android</p>
                <div class="modal">
                  <div class="qr_code">
                    <img v-if="getHost() === 'ovpn-test.yy.com'" src="@/assets/mobile_home_test.png"
                         style="width: inherit; height: inherit"/>
                    <img v-else src="@/assets/mobile_home.png" style="width: inherit; height: inherit"/>
                    <p>微信扫描二维码</p>
                    <p>下载Android客户端</p>
                  </div>
                </div>
              </a>
            </div>


            <div id="ios_version" class="item">
              <a :href="getIOSDownloadUrl()">
                <i class="iconfont">
                  <svg-icon icon-class="ios"></svg-icon>
                </i>
                <p>iPhone</p>
                <div class="modal">
                  <div class="qr_code">
                    <img v-if="getHost() === 'ovpn-test.yy.com'" src="@/assets/mobile_home_test.png"
                         style="width: inherit; height: inherit"/>
                    <img v-else src="@/assets/mobile_home.png" style="width: inherit; height: inherit"/>
                    <p>微信扫描二维码</p>
                    <p>下载iPhone客户端</p>
                  </div>
                </div>
              </a>
            </div>

            <div id="mac_version" class="item">
              <a @click="isInnerIp?dialogVisible=true:dialogVisible=false; selectedOs='mac';"
                 :href="isInnerIp?'#':downloadUrl.mac.download_url">
                <i class="iconfont">
                  <svg-icon icon-class="mac"></svg-icon>
                </i>
                <p>Mac</p>
                <div class="modal">
                  <div class="iconfont">
                    <svg-icon icon-class="download"></svg-icon>
                  </div>
                  <p>点击下载Mac客户端</p>
                </div>
              </a>
            </div>

            <div id="windows_version" class="item">
              <a
                @click="isInnerIp?dialogVisible=true:(dialogVisible=false,dialogWindowVisible=true); selectedOs='windows';">
                <i class="iconfont">
                  <svg-icon icon-class="windows"></svg-icon>
                </i>
                <p style="margin-bottom: 0">Windows</p>
                <p class="win-bit">(32/64位)</p>
                <div class="modal">
                  <div class="iconfont">
                    <svg-icon icon-class="download"></svg-icon>
                  </div>
                  <p>点击下载Windows客户端</p>
                </div>
              </a>
            </div>
          </div>

          <div class="product-feature">
            <div class="title web-font">
              <p>产品特性</p>
            </div>
            <div class="feature-content">
              <ul>
                <li><p>告别繁琐流程：无需动态口令，无需配置</p></li>
                <li><p>建立安全会话：双重认证，SSL加密</p></li>
                <li><p>让连接更简便：OA账号登录，也支持扫码登录</p></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="description">
        <div class="text-title">
          使用说明
        </div>
        <div class="border-line"></div>

        <div class="text-box">
          <span class="desc-title">
            <svg-icon icon-class="computer"></svg-icon>
            PC客户端(Windows/Mac)</span>
          <div class="desc-body">
            <ul>
              <li><p>如果在公司内网，访问<a href="http://pm.yy.com/#/auto_install">一键部署系统</a>自动安装和配置，安装成功后可使用多种认证方式建立VPN连接</p>
              </li>
              <li><p>远程在外不方便，可直接在本页面下载客户端，然后用手机端YYVPN扫码登录</p></li>
            </ul>
          </div>

          <div class="space"></div>

          <span class="desc-title">
            <svg-icon icon-class="mobile"></svg-icon>
            移动端(Android/iPhone)
          </span>
          <div class="desc-body">
            <ul>
              <li><p>首次外网连接，通过OA手机短信验证码认证</p></li>
              <li><p>内网连接成功后，该手机自动认证为员工可信任移动设备</p></li>
            </ul>
          </div>
        </div>

      </div>
      <div class="ovpn-footer-content">
        <p>联系方式：020-32313300</p>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible">
      <template slot="title">
        <p style="text-align: center">安装{{ myFormatOS(selectedOs) }}客户端</p>
      </template>
      <div v-if="isInnerIp">
        <el-row style="margin-bottom: 20px">
          <p>检测到当前网络环境为公司办公网</p>
          <p>推荐使用"一键部署"方式安装，跳转到一键部署系统自动安装</p>
          <p>在内网完成认证，登录更简单</p>
        </el-row>
        <el-row style="text-align: center" class="button-orange">
          <el-button type="primary" v-if="isInnerIp && (browserOs === 'mac' || browserOs === 'windows')">
            <a href="http://pm.yy.com/#/auto_install">一键部署（推荐）</a>
          </el-button>
          <span class="orange-a" style="margin-left: 10px">
            <a v-if="selectedOs === 'mac'" :href="downloadUrl.mac.download_url">直接下载</a>
            <a v-else-if="selectedOs === 'windows'" href="#" @click="dialogWindowVisible=true">直接下载</a>
            <a v-else>暂无下载链接</a>
          </span>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogWindowVisible">
      <template slot="title">
        <p style="text-align: center">安装{{ myFormatOS(selectedOs) }}客户端</p>
      </template>
      <div>
        <!--提供32位 and 64位下载入口-->
        <el-row>
          <ul>
            <li>
              <span class="orange-a">
                <a :href="downloadUrl.windows.download_url" v-if="downloadUrl.windows">{{ myFormatOS(selectedOs) }} 64位下载链接</a>
                <a v-else>暂无64位下载链接</a>
              </span>
              <span v-if="systemBit==='x64' && browserOs === 'windows'">
                [检测到当前系统为64位]
              </span>
            </li>
            <li style="margin-top: 20px">
              <span class="orange-a" v-if="downloadUrl.win32 && downloadUrl.win32.download_url">
                <a :href="downloadUrl.win32.download_url">
                  {{ myFormatOS(selectedOs) }} 32位下载链接(支持win7及以上)
                </a>
              </span>
              <span v-else>
                暂未开放32位下载链接，敬请期待
              </span>
              <span v-if="systemBit==='x86' && browserOs === 'windows'">
                [检测到当前系统为32位]
              </span>
            </li>
          </ul>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {getClientNewestVersion, checkIsInnerIp, postBrowserAgent} from '@/api'
  import {getBrowserOs, formatOS, getSystemBit} from '@/utils'

  export default {
    name: "Home",
    data() {
      return {
        versionInfo: [],
        browserOs: '',
        downloadUrl: {
          android: {download_url: ''},
          ios: {download_url: ''},
          mac: {download_url: ''},
          windows: {download_url: ''},
          win32: {download_url: ''},
        },
        dialogVisible: false,
        dialogWindowVisible: false,
        selectedOs: '',
        isInnerIp: false,
        systemBit: 'x64',  //操作系统位数 32位/64位
      }
    },
    created() {
      this.fetchClientVersion();
      this.getIsInnerIp();
      this.browserOs = getBrowserOs();
      this.systemBit = getSystemBit();
    },
    methods: {
      handleSelect(key, keyPath) {
        if (keyPath.length >= 2 && keyPath[1] === '1-manager') {
          console.log('push router');
          if (window.location.host === 'ovpn.yy.com') {
            window.location.href = 'https://ovpn-mgr.yy.com/#/index/dashboard';
          } else if (window.location.host === 'ovpn-test.yy.com') {
            window.location.href = 'https://ovpn-mgr-test.yy.com/#/index/dashboard';
          } else if (window.location.host === 'ovpn.duowan.com') {
            window.location.href = 'https://ovpn-mgr.duowan.com/#/index/dashboard';
          } else if (window.location.host === 'ovpn-test.duowan.com') {
            window.location.href = 'https://ovpn-mgr-test.duowan.com/#/index/dashboard';
          } else {
            console.log('window.location.href=', window.location.href);
          }
        }
      },
      fetchClientVersion() {
        getClientNewestVersion().then(resp => {
          if (resp.code === 0) {
            for (var i in resp.data) {
              switch (resp.data[i].os) {
                case 'android':
                  this.downloadUrl.android = resp.data[i];
                  break;
                case 'ios':
                  this.downloadUrl.ios = resp.data[i];
                  break;
                case 'mac':
                  this.downloadUrl.mac = resp.data[i];
                  break;
                case 'windows':
                  this.downloadUrl.windows = resp.data[i];
                  break;
                case 'win32':
                  this.downloadUrl.win32 = resp.data[i];
                  break;
              }
              this.versionInfo.push(resp.data[i]);
            }
            console.log('getClientNewestVersion: ', this.versionInfo);
          }
        });
      },
      getIsInnerIp() {
        checkIsInnerIp().then(resp => {
          this.isInnerIp = (resp.code === 0);
        });
      },
      myFormatOS(os) {
        return formatOS(os);
      },
      getHost() {
        return window.location.host;
      },
      getIOSDownloadUrl() {
        return 'itms-services://?action=download-manifest&url=' + this.downloadUrl.ios.download_url
      }
    }
  }
</script>

<style scoped>
  html, body {
    height: 100%;
  }

  .menu-title {
    color: #ED7F22;
    font-weight: 500;
    font-size: 26px;
    height: 60px;
    line-height: 60px;
    margin-left: 20px;
  }

  .text-container {
    background-color: #304156;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: auto;
  }

  @media only screen and (max-width: 600px) {
    .text-middle {
      left: 0;
      right: 0;
      width: 98%;
      margin: 30px auto;
      position: absolute;
    }
  }

  @media only screen and (min-width: 600px) {
    .text-middle {
      left: 0;
      right: 0;
      width: 85%;
      margin: 30px auto;
      position: absolute;
    }
  }

  .text-space {
    padding: 20px;
  }

  .text-title {
    font-weight: 700;
    font-size: 1.5em;
    color: #ED7F22;
    line-height: 2em;
  }

  .text-box {
    background: white;
    padding: 4% 4%;
    min-height: 50px;
    border-radius: 15px;
    table-layout: fixed;
  }


  li p {
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    line-height: 2em;
  }

  .desc-title {
    font-size: 1.3em;
    display: table-row;
    line-height: 2em;
    position: relative;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .border-line {
    border-bottom: 1px solid lightgray;
  }

  .desc-body {
    font-size: 0.9em;
    line-height: 2em;
    position: relative;
    width: 100%;
    height: 100%;
    display: inline-table;
    padding: 10px 10px;
    color: #333;
    word-wrap: break-word;
    word-break: break-all;
  }

  .space {
    margin-bottom: 30px;
  }

  /deep/ .el-tabs__item.is-active {
    color: #ED7F22;
  }

  /deep/ .el-tabs__item:hover {
    color: #ED7F22;
  }

  .download-content {
    width: 100%;
    height: 100%;
    background: #fff;
  }

  .download_card {
    width: 1200px;
    padding: 64px 100px 32px 100px;
    background: #fff;
    overflow: hidden;
    margin: auto;
  }

  .download_card .phone {
    width: 240px;
    height: 486px;
    border-radius: 30px;
    border: 1px solid #e4e4e4;
    padding-top: 55px;
    float: left;
  }

  .download_card .phone .screen {
    width: 215px;
    height: 377px;
    border: 1px solid #e4e4e4;
    margin: auto;
  }

  .vpn-download-pic {
    width: 150px;
    height: 150px;
    margin: 0 auto;
    margin-top: 80px;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: 150px 150px;
  }

  .download_card .phone p {
    text-align: center;
    font-size: 12px;
    color: #666;
    margin: 10px 0;
  }

  .download_card .content {
    float: right;
  }

  .download_card .content .title {
    font-size: 30px;
    margin-top: 20px;
    color: #333;
  }

  .download_card .content .title i {
    font-size: 18px;
  }

  .web-font {
    font-family: "webfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
  }

  .download_card .content .desc {
    font-size: 14px;
    color: #999;
    margin-top: 5px;
  }

  .download_card .content .list {
    margin-top: 26px;
    overflow: hidden;
  }

  .download_card .list .item {
    /*margin-left: 10px;*/
    float: left;
    width: 168px;
    height: 168px;
    border: 1px solid #e4e4e4;
    text-align: center;
    padding-top: 30px;
    display: block;
    position: relative;
    cursor: pointer;
    color: #999;
  }

  .download_card .list .item + .item {
    margin-left: 9px;
  }

  .download_card .item .iconfont {
    font-size: 60px;
    color: #939799;
  }

  .download_card p.win-bit {
    font-size: 12px;
    color: #999999;
    margin-top: 5px;
  }

  .download_card .item .modal {
    width: 166px;
    height: 166px;
    position: absolute;
    left: 0;
    top: 0;
    background: #f8f8f8;
    display: none;
  }

  .download_card .item:hover .modal {
    display: block;
  }

  .download_card .modal .qr_code {
    width: 100px;
    height: 100px;
    margin: 15px auto 12px;
  }

  .download_card .modal p {
    text-align: center;
    font-size: 12px;
    color: #666;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .download_card .modal .iconfont {
    font-size: 86px;
    color: #939799;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .ovpn-footer {
    position: relative;
    background-color: #303036;
    color: #fff;
    height: 50px;
    min-width: 1180px;
    display: block;
    box-sizing: border-box;
  }

  .ovpn-footer-content {
    /*width: 100%;*/
    min-width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
    display: flex;
    justify-content: center;
    background-color: #303036;
  }

  .ovpn-footer-content p {
    float: left;
    margin: 0 0 0 5px;
    color: white;
    font-size: 0.8em;
  }

  /deep/ .button-orange .el-button--primary {
    background-color: #ED7F22;
    border-color: #ED7F22;
  }

  /deep/ .button-orange .el-button--primary:hover {
    background-color: rgba(237, 127, 34, 0.6);
    border-color: rgba(237, 127, 34, 0.6);;
  }

  /deep/ .button-orange .el-button--default:hover {
    background-color: rgba(237, 127, 34, 0.21);
    color: #ED7F22;
    border-color: #ED7F22;
  }

  .orange-a a {
    color: #ED7F22;
    text-decoration: underline;
  }

  .product-feature .title p {
    color: #333;
    font-size: 18px;
  }

  .product-feature .feature-content li {
    color: #939799;
    font-size: 1em;
    font-weight: 400;
  }

  .description {
    width: 1200px;
    padding: 0 64px 100px 100px;
    background: #fff;
    overflow: hidden;
    margin: auto;
  }

  .description .text-title {
    text-align: center;
  }

  .desc-body a {
    color: #ED7F22;
    text-decoration: underline;
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue